module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "20px 0px",
      "text-align": "left"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "topForm",
    attrs: {
      "inline": true,
      "model": _vm.topForm
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" 新增\n                ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "8%"
    },
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "提货码名称"
    },
    model: {
      value: (_vm.topForm.name),
      callback: function($$v) {
        _vm.$set(_vm.topForm, "name", $$v)
      },
      expression: "topForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "2%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.getData()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加库存",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        _vm.dialodclose('exlForm')
      }
    }
  }, [_c('el-form', {
    ref: "exlForm",
    attrs: {
      "model": _vm.exlForm,
      "rules": _vm.exlrules
    }
  }, [(_vm.isable == false) ? _c('el-form-item', {
    attrs: {
      "label": "库存",
      "prop": "count"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入库存数量"
    },
    model: {
      value: (_vm.exlForm.count),
      callback: function($$v) {
        _vm.$set(_vm.exlForm, "count", $$v)
      },
      expression: "exlForm.count"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isable == true) ? _c('el-form-item', {
    attrs: {
      "prop": "fileList",
      "label": "导入库存"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadurl,
      "data": _vm.upload_data,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handletype,
      "file-list": _vm.exlForm.fileList
    }
  }, [_c('span', {
    class: {
      isable: _vm.isorno
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("大小不超过5GB")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "表格名称",
      "prop": "exlName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "exlName"
    },
    model: {
      value: (_vm.exlForm.exlName),
      callback: function($$v) {
        _vm.$set(_vm.exlForm, "exlName", $$v)
      },
      expression: "exlForm.exlName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('exlForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "excodeName",
      "label": "提货码名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "总数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remain",
      "label": "库存数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "excodeType",
      "label": "提货码类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.excodeType == 1) ? _c('div', [_vm._v("预生成")]) : _vm._e(), _vm._v(" "), (scope.row.excodeType == 0) ? _c('div', [_vm._v("系统生成")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expTime",
      "label": "过期时间",
      "formatter": _vm.formatterstart
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "255px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.advertiseEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.status == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.unassignAct(scope.row)
            }
          }
        }, [_vm._v("停用")]) : _vm._e(), _vm._v(" "), (scope.row.status == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.assignAct(scope.row)
            }
          }
        }, [_vm._v("启用")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.addKuCun(scope.row)
            }
          }
        }, [_vm._v("添加库存")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04cb6e89!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/excode/ExcodeManager.vue
// module id = 1027
// module chunks = 2